var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
import { db } from 'data/firestoreClient';
export var fetchPostsByType = function (Type, lastPostId) { return __awaiter(_this, void 0, void 0, function () {
    var parsedData, query, posts, lastVisible;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                parsedData = [];
                if (lastPostId !== '') {
                    console.log('second');
                    query = db.collection('posts')
                        .where('Type', '==', Type)
                        .orderBy('available', 'desc')
                        .limit(10)
                        .startAfter(lastPostId);
                }
                else {
                    console.log('first');
                    query = db.collection('posts')
                        .where('Type', '==', Type)
                        .orderBy('available', 'desc')
                        .limit(10);
                }
                return [4 /*yield*/, query.get()];
            case 1:
                posts = _a.sent();
                lastVisible = posts.docs[posts.docs.length - 1];
                console.log(posts);
                posts.forEach(function (postResult) {
                    var _a;
                    var post = postResult.data();
                    console.log('QUERY', post.id);
                    parsedData = parsedData.concat([
                        (_a = {},
                            _a[postResult.id] = __assign({ id: postResult.id }, post),
                            _a)
                    ]);
                });
                return [2 /*return*/, ({ posts: parsedData, last: lastVisible })];
        }
    });
}); };
export var fetchPostsByTypeLimit = function (Type, lastPostId) { return __awaiter(_this, void 0, void 0, function () {
    var parsedData, query, posts, lastVisible;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                parsedData = [];
                query = db.collection('posts')
                    .where('Type', '==', Type)
                    .orderBy('available', 'desc')
                    .limit(5);
                return [4 /*yield*/, query.get()];
            case 1:
                posts = _a.sent();
                lastVisible = posts.docs[posts.docs.length - 1];
                console.log(posts);
                posts.forEach(function (postResult) {
                    var _a;
                    var post = postResult.data();
                    console.log('QUERY', post.id);
                    parsedData = parsedData.concat([
                        (_a = {},
                            _a[postResult.id] = __assign({ id: postResult.id }, post),
                            _a)
                    ]);
                });
                return [2 /*return*/, ({ posts: parsedData, last: lastVisible })];
        }
    });
}); };
export var fetchPostsByUserId = function (userId, lastPostId, limit) { return __awaiter(_this, void 0, void 0, function () {
    var parsedData, query, posts, lastVisible;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                parsedData = [];
                if (lastPostId !== '') {
                    console.log('second pro');
                    query = db.collection('posts')
                        .where('ownerUserId', '==', userId)
                        .orderBy('creationDate', 'desc')
                        .orderBy('available', 'desc')
                        .startAfter(lastPostId)
                        .limit(limit ? limit : 15);
                }
                else {
                    query = db.collection('posts')
                        .where('ownerUserId', '==', userId)
                        .orderBy('creationDate', 'desc')
                        .orderBy('available', 'desc')
                        .limit(limit ? limit : 15);
                }
                return [4 /*yield*/, query.get()];
            case 1:
                posts = _a.sent();
                lastVisible = posts.docs[posts.docs.length - 1];
                posts.forEach(function (postResult) {
                    var _a;
                    var post = postResult.data();
                    parsedData = parsedData.concat([
                        (_a = {},
                            _a[postResult.id] = __assign({ id: postResult.id }, post),
                            _a)
                    ]);
                });
                return [2 /*return*/, ({ posts: parsedData, last: lastVisible })];
        }
    });
}); };
// export const getPosts: (currentUserId: string, lastPostId: string, page: number, limit: number)
//     => Promise<{ posts: { [postId: string]: Post }[], newLastPostId: string }> = (currentUserId, lastPostId, page = 0, limit = 10) => {
//         return new Promise<{ posts: { [postId: string]: Post }[], newLastPostId: string }>((resolve, reject) => {
//             let postList: { [postId: string]: Post }[] = []
//             // Get user ties
//             db.collection('graphs:users').where('leftNode', '==', currentUserId)
//                 .get().then((tieUsers) => {
//                     if (!(tieUsers.size > 0)) {
//                         // Get current user posts
//                         this.getPostsByUserId(currentUserId, lastPostId, page, limit).then((result) => {
//                             resolve(result)
//                         })
//                     }
//                     let userCounter = 0
//                     const userIdList: Array<string> = []
//                     tieUsers.forEach((item) => {
//                         const userId = item.data().rightNode
//                         if (!userIdList.includes(userId)) {
//                             // Get user tie posts
//                             this.getPostsByUserId(userId).then((posts) => {
//                                 userCounter++
//                                 postList = [
//                                     ...postList,
//                                     ...posts.posts
//                                 ]
//                                 if (userCounter === tieUsers.size) {
//                                     // Get current user posts
//                                     this.getPostsByUserId(currentUserId).then((result) => {
//                                         postList = [
//                                             ...postList,
//                                             ...result.posts
//                                         ]
//                                         resolve(this.pagingPosts(postList, lastPostId, limit))
//                                     })
//                                 }
//                             })
//                         }
//                     })
//                 })
//                 .catch((error: any) => {
//                     reject(new SocialError(error.code, error.message))
//                 })
//         })
//     }



//////////////////
// WEBPACK FOOTER
// ./src/containers/Stream2/reducer.ts
// module id = 966
// module chunks = 0 1 2 3 4 5 6 7